import { render, staticRenderFns } from "./GreenCoffeeBulkImportHistory.vue?vue&type=template&id=04b41a6c&scoped=true"
import script from "./GreenCoffeeBulkImportHistory.vue?vue&type=script&lang=js"
export * from "./GreenCoffeeBulkImportHistory.vue?vue&type=script&lang=js"
import style0 from "./GreenCoffeeBulkImportHistory.vue?vue&type=style&index=0&id=04b41a6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b41a6c",
  null
  
)

export default component.exports